import { ApolloError } from '@apollo/client';

import {
  IPaginationProps,
  LoadedContent,
  Pagination,
  Typography,
} from '@occc-app/design-system/components';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  LinearProgress,
  SearchForm,
  SearchFormProps,
} from '@occc-app/design-system';
import { RetailerNetworkTobaccoProgramSiteMetric } from '@occc/graphql';

import { LocationRankingTableRow } from './location-ranking-table-row.component';

type LocationRankingTableProps = {
  data?: RetailerNetworkTobaccoProgramSiteMetric[];
  loading: boolean;
  error?: ApolloError;
  paginationProps: IPaginationProps;
  onSearchSubmit: SearchFormProps['onSubmit'];
  valueLabel: string;
};

export const LocationRankingTable = (props: LocationRankingTableProps) => {
  const { data, loading, error, paginationProps, onSearchSubmit, valueLabel } = props;

  const renderData = (items: Exclude<LocationRankingTableProps['data'], undefined>) => (
    <>
      {loading && <LinearProgress />}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Rank</TableCell>
            <TableCell>Site ID</TableCell>
            <TableCell>Site Name</TableCell>
            <TableCell>Address</TableCell>
            <TableCell align='right'>{valueLabel}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <LocationRankingTableRow key={item.siteId} item={item} />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </>
  );

  return (
    <TableContainer>
      <TableHeader
        title={
          <Typography variant='subtitle1' fontWeight={600}>
            Location Ranking
          </Typography>
        }
        actions={<SearchForm onSubmit={onSearchSubmit} />}
      />
      <LoadedContent error={error} loading={loading} items={data} renderData={renderData} />
    </TableContainer>
  );
};
